import { ProductPartnership } from "@/shared/enums/product-partnership.enum";
import { StorePartnershipGetters } from "@/shared/models/store-partnership.model";

const getters: StorePartnershipGetters = {
  getClaim: (state) => state.claim,
  getClaims: (state) => state.claims,
  getClaimsMeta: (state) => state.claimsMeta,
  getClaimsHistoriesClaim: (state) => state.claimHistory,
  getPartners: (state) => state.partners,
  getPolicies: (state) => state.policies,
  getPoliciesMeta: (state) => state.policiesMeta,
  getPolicy: (state) => state.policy,
  getUploadProgress: (state) => state.uploadProgress,
  isMicroHealth: (state) => state.product === ProductPartnership.MicroHealth,
  isFinance: (state) => state.product === ProductPartnership.Finance,
  isTravel: (state) => state.product === ProductPartnership.Travel,
  isGadget: (state) => state.product === ProductPartnership.Gadget,
  getInvoices: (state) => state.invoices,
  getInvoicesMeta: (state) => state.invoicesMeta,
  getInvoicesHistories: (state) => state.invoiceHistory,
  getClaimDisbursement: (state) => state.claimsDisbursement,
  getClaimsDisbursementMeta: (state) => state.claimsDisbursementMeta,
  getClaimDisbursementDetail: (state) => state.claimDisbursementDetail,
  getClaimDisbursementHistories: (state) => state.claimDisbursementHistory,
  getInvoice: (state) => state.invoice,
  getClaimPools: (state) => state.claimPools,
  getClaimPoolsMeta: (state) => state.claimPoolsMeta,
  getClaimPool: (state) => state.claimPool,
  getGadgets: (state) => state.gadgets,
  getGadgetsMeta: (state) => state.gadgetsMeta,
  getGadgetsAll: (state) => state.gadgetsAll,
  getGadgetCategory: (state) => state.gadgetCategory,
  getListBrand: (state) => state.listBrand,
};

export default getters;
